'use strict'

export const EPAYCO_TEST_MODE = process.env.VUE_APP_EPAYCO_TEST_MODE

export const METHODS_DISABLE_AGREGADOR = ['TDC', 'PSE', 'SP', 'DP']
export const METHODS_DISABLE_GATEWAY = ['CASH']
